import { Injectable } from '@angular/core';
import { CanLoad, Route, Router } from '@angular/router';

import { PAGES, PTRAB_PAGES, WEBVIEW_LINK_ROUTES } from '@app/shared/enums/pages/pages.enum';
import { WebViewService } from '@app/shared/services/webview.service';
import { StorageService } from '@services/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class WebViewGuardService implements CanLoad {
  constructor(private router: Router, private webViewService: WebViewService) {}
  canLoad(route: Route): boolean {
    if (this.webViewService.isWebView() && !WEBVIEW_LINK_ROUTES.includes(route.path as PAGES | PTRAB_PAGES)) {
      this.router.navigateByUrl(StorageService.getWebViewPath());
      return false;
    }
    return true;
  }
}
